export const UseCases = Object.freeze({
    "RESTAURANT": "restaurant"
});